import { env } from '@/lib/runtime-env'

export const SEARCH_PARAM_KEYS = {
  HTC_TOKEN: 'htc_account_access_token',
  RETICULUM_TOKEN: 'reticulum_token',
  EMAIL: 'email',
  RETRY_AFTER: 'retry_after',
  AVATAR: 'avatar_url',
  SNAPSHOT: 'snapshot_url',
  HEAD_ICON: 'head_icon_url',
  DISPLAY_NAME: 'display_name',
  IS_HALF_BODY: 'is_half_body',
  GENDER: 'gender',
  IS_NEW_USER: 'is_new_user',
  OPEN_CREATE_DIALOG: 'create',
  CREATE_DIALOG_TEMPLATE_TYPE: 'template',
  SOURCE: 'source',
  APP_ID: 'app_id',
  APP_STATE: 'app_state',
  STATE: 'state',
  PREVIEW: 'preview',
} as const

export const AUTH_CONTINUATION_PARAM = 'auth_continuation'

export const AUTH_CONTINUATIONS = {
  VIVERSE_PLUS_SGE_REDEEM: 'viverse_plus_sge_redeem',
} as const

export const AUTH_RECOVERY_REFRESH_PENDING_KEY = 'auth-recovery-refresh-pending'
export const AUTH_RECOVERY_REFRESH_PENDING_TTL_MS = 5 * 60 * 1000

export const DOB_OAUTH_AUTHORIZE_PATH = '/SS/Services/OAuth/Authorize'
export const DOB_OAUTH_FORCE_VIEW = 'dob-select'
export const DOB_OAUTH_SCOPE = 'issuetoken email profile.write'
export const DOB_OAUTH_STATE_SCOPE = DOB_OAUTH_SCOPE.replace(/ /g, '+')
export const DOB_OAUTH_AUTHORITIES = 'htc.com+metamask.com+walletconnect.com+google.com+steam.com'

const runtimeEnvironment = env('NEXT_PUBLIC_ENVIRONMENT') ?? ''

const environmentSuffix =
  { production: 'production', development: 'dev' }[runtimeEnvironment] ?? 'stage'

export const HTC_ACCESS_TOKEN_KEY = `_htc_access_token_${environmentSuffix}`
export const HTC_REFRESH_TOKEN_KEY = `_htc_refresh_token_${environmentSuffix}`
export const HTC_AUTH_COOKIE_KEYS = [HTC_ACCESS_TOKEN_KEY, HTC_REFRESH_TOKEN_KEY] as const

// Keys stripped from the URL after sign-in; shareable params are preserved.
export const OAUTH_CALLBACK_KEYS_TO_STRIP = Object.values(SEARCH_PARAM_KEYS).filter(
  (key) =>
    key !== SEARCH_PARAM_KEYS.OPEN_CREATE_DIALOG &&
    key !== SEARCH_PARAM_KEYS.CREATE_DIALOG_TEMPLATE_TYPE &&
    key !== SEARCH_PARAM_KEYS.PREVIEW &&
    key !== SEARCH_PARAM_KEYS.APP_STATE &&
    key !== SEARCH_PARAM_KEYS.STATE,
)
